import { useVerifierSignal } from "../hooks";

type Signal = {
  id: string; regleCode: string; constat: string; preuve: string; urlPreuve: string;
  poids: number; confiance: string; statutVerification: string;
};

export function ListeSignaux({ prospectId, signaux }: { prospectId: string; signaux: Signal[] }) {
  const verifier = useVerifierSignal(prospectId);

  if (signaux.length === 0) {
    return <p className="etat">Aucun constat détecté. Relancer une analyse depuis l'espace Prospection.</p>;
  }

  return (
    <section className="panel">
      <h2 className="blocktitle">Constats — décocher ce que le client infirme</h2>
      {signaux.map(s => {
        const infirme = s.statutVerification === "infirme_client";
        return (
          <article key={s.id} className={`signal ${s.poids < 0 ? "neg" : ""} ${infirme ? "off" : ""}`}>
            <div className="code">
              {s.regleCode} · confiance {s.confiance} ·{" "}
              <span className={`poids ${s.poids < 0 ? "neg" : ""}`}>{s.poids > 0 ? "+" : ""}{s.poids}</span>
            </div>
            <p className="txt">{s.constat}</p>
            <blockquote>{s.preuve}</blockquote>
            <div className="ligne">
              <button className="btn ghost sm" disabled={verifier.isPending}
                      onClick={() => verifier.mutate({ signalId: s.id, statut: infirme ? "confirme_client" : "infirme_client" })}>
                {infirme ? "Rétablir le constat" : "Infirmé par le client"}
              </button>
              <a href={s.urlPreuve} target="_blank" rel="noopener" className="mono petit">Voir la preuve ↗</a>
            </div>
          </article>
        );
      })}
    </section>
  );
}
